import React from 'react';
import { useSelector } from 'react-redux';

import { useCurrentEditor } from '@tiptap/react';
import { Button } from 'antd';

import BoldIcon from '../../../../../resources/icons/editor/BoldIcon';
import CodeIcon from '../../../../../resources/icons/editor/CodeIcon';
import ItalicIcon from '../../../../../resources/icons/editor/ItalicIcon';
import UnderlineIcon from '../../../../../resources/icons/editor/UnderlineIcon';

import { selectDarkMode } from '../../../../../userBrowserSettings/store/browserSettings.selectors';

import { getIconColorByDarkMode } from '../constants';

import { getThemeColorClass } from '../../../../../utils/helpers/themeHelpers';

import ToolbarTooltip from '../ToolbarTooltip';

const classes = {
    markButtonsSection: 'mark-buttons-section',
};

const MarkButtonsSection = ({ disabled = false }) => {
    const { editor } = useCurrentEditor();

    const darkMode = useSelector(selectDarkMode);

    const themeColorClass = getThemeColorClass(darkMode);

    return (
        <div className={`${classes.markButtonsSection} ${themeColorClass}`}>
            <ToolbarTooltip disabled={disabled} title='Bold'>
                <Button
                    disabled={disabled}
                    className={editor.isActive('bold') ? 'active' : ''}
                    icon={<BoldIcon color={getIconColorByDarkMode(darkMode)} />}
                    onClick={() => editor.chain().focus().toggleBold().run()}
                />
            </ToolbarTooltip>
            <ToolbarTooltip disabled={disabled} title='Italic'>
                <Button
                    disabled={disabled}
                    icon={<ItalicIcon color={getIconColorByDarkMode(darkMode)} />}
                    className={editor.isActive('italic') ? 'active' : ''}
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                />
            </ToolbarTooltip>
            <ToolbarTooltip disabled={disabled} title='Underline'>
                <Button
                    disabled={disabled}
                    icon={<UnderlineIcon color={getIconColorByDarkMode(darkMode)} />}
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    className={editor.isActive('underline') ? 'active' : ''}
                />
            </ToolbarTooltip>
            <ToolbarTooltip disabled={disabled} title='Code'>
                <Button
                    disabled={disabled}
                    icon={<CodeIcon color={getIconColorByDarkMode(darkMode)} />}
                    onClick={() => editor.chain().focus().toggleCode().run()}
                    className={editor.isActive('code') ? 'active' : ''}
                />
            </ToolbarTooltip>
        </div>
    );
};

export default MarkButtonsSection;
